import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class TaskStatusService {


  constructor(private http: HttpClient) { }
  
    url = environment.serverAPI9 + "/api/taskStatus";
  
    taskStatus(Page: number, size: number, sort: any, type: any): Observable<Object> {
      return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}&type=${type}`);
    }

    getAlltaskStatusDropDown(type: any): Observable<Object> {
      return this.http.get(`${this.url}/dropdown?type=${type}`);
    }
  
    taskStatusSearch(query: any, Page: any, size: any, sort: any, type: any): Observable<Object> {
  
      return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}&type=${type}`);
    }
    synctaskStatusPageData() {
      return this.http.get(`${this.url}/page/sync`);
    }
  
  
    public responseCache = new Map();
  
    public getAlltaskStatusDropDownCache(): Observable<any> {
  
      const taskStatusFromCache = this.responseCache.get(`${this.url}/dropdown`);
  
      if (taskStatusFromCache) {
        return of(taskStatusFromCache);
      } else {
        return this.http.get<any>(`${this.url}/dropdown`).pipe(
          tap(taskStatus => this.responseCache.set(`${this.url}/dropdown`, taskStatus))
        );
      }
  
    }
  
  
    newtaskStatus(taskStatus: any): Observable<any> {
      return this.http.post<any>(`${this.url}`, taskStatus).pipe(
        tap(() => this.delete())
      );
    }
  
    delete() {
      this.responseCache.delete(`${this.url}`)
    }
  
  
  }
  